import * as React from 'react'
import NavBar from "../components/NavBar";
import Divider from '@mui/material/Divider';

import {CircleOutlined, AdjustOutlined, CheckCircle} from '@mui/icons-material';
import {useTranslation} from "react-i18next";
import {handleSetServicesLogo} from "../assets/js/main";


export default function MyPackage() {
  const {t} = useTranslation()


  return (
     <>
       <div className="myPackagePage desktopSection">
         <div className="headerPage">
           <NavBar position back/>
         </div>

         <div className="container">
           <div className="bodyPage">
             <div className="titlePage">
               <h4 className="titleSection">{t("myPackage.t1")}</h4>
               <img src={require('../assets/img/package.png')} alt=""/>
             </div>

             <div className="row">
               <div className="col-6 col-lg-4">
                 <p>{t("myPackage.t2")}:</p>
                 <span>784561</span>
               </div>
               <div className="col-6 col-lg-4">
                 <p>{t("myPackage.t3")}:</p>
                 <span>امین سیرایی</span>
               </div>
               <div className="col-12">
                 <p>{t("myPackage.t4")}:</p>
                 <span>تهران - شهرک اکباتان - بیمه چهارم</span>
               </div>
               <div className="col-6 col-lg-4">
                 <p>{t("myPackage.t5")}:</p>
                 <div className="d-flex">
                   <img src={handleSetServicesLogo("پست پیشتاز")} alt="پست پیشتاز"/>
                   <span>پست پیشتاز</span>
                 </div>
               </div>
               <div className="col-6 col-lg-4">
                 <p>{t("myPackage.t6")}:</p>
                 <span>16 ساعت و 35 دقیقه</span>
                 <div className="slide">
                   <div className="slideValue"/>
                 </div>
               </div>
             </div>

             <Divider/>

             <div className="packageDate">
               <h4 className="titleSection">{t("myPackage.t7")}</h4>

               <div className="stepper">
                 <div className="item check">
                   <div>
                     <div className="icon">
                       {/*<CircleOutlined/>*/}
                       {/*<AdjustOutlined/>*/}
                       <CheckCircle/>
                     </div>
                     <span>{t("myPackage.t8")}</span>
                   </div>
                   <div>
                     <span className="date">1400/05/26 | 15:13:30</span>
                   </div>
                 </div>
                 <div className="item check">
                   <div>
                     <div className="icon">
                       <div className="line"/>
                       {/*<CircleOutlined/>*/}
                       {/*<AdjustOutlined/>*/}
                       <CheckCircle/>
                     </div>
                     <span>{t("myPackage.t9")}</span>
                   </div>
                   <div>
                     <span className="date">1400/05/26 | 15:13:30</span>
                   </div>
                 </div>
                 <div className="item check">
                   <div>
                     <div className="icon">
                       <div className="line"/>
                       {/*<CircleOutlined/>*/}
                       <AdjustOutlined/>
                       {/*<CheckCircle/>*/}
                     </div>
                     <span>{t("myPackage.t10")}</span>
                   </div>
                   <div>
                     <span className="date">1400/05/26 | 15:13:30</span>
                   </div>
                 </div>
                 <div className="item empty">
                   <div>
                     <div className="icon">
                       <div className="line"/>
                       <CircleOutlined/>
                       {/*<AdjustOutlined/>*/}
                       {/*<CheckCircle/>*/}
                     </div>
                     <span>{t("myPackage.t11")}</span>
                   </div>
                   <div>
                     <span className="date"></span>
                   </div>
                 </div>
               </div>
             </div>


           </div>
         </div>


       </div>
     </>
  )
}
